import React from 'react'
import { Edit } from 'react-admin'
import SupplierForm from 'ui-shared/FormComponents/SupplierForm'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'

const SupplierEdit: React.FC = () => {
  return (
    <SectionWrapper>
      <Edit>
        <SupplierForm toolbar={<WithDeleteModalToolbar />} />
      </Edit>
    </SectionWrapper>
  )
}

export default SupplierEdit
